import { render, staticRenderFns } from "./blood.vue?vue&type=template&id=6a43945f&scoped=true&"
import script from "./blood.vue?vue&type=script&lang=js&"
export * from "./blood.vue?vue&type=script&lang=js&"
import style0 from "./blood.vue?vue&type=style&index=0&id=6a43945f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43945f",
  null
  
)

export default component.exports